import { render, staticRenderFns } from "./evaStudent.vue?vue&type=template&id=c12058f0&scoped=true&"
import script from "./evaStudent.vue?vue&type=script&lang=js&"
export * from "./evaStudent.vue?vue&type=script&lang=js&"
import style0 from "./evaStudent.vue?vue&type=style&index=0&id=c12058f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12058f0",
  null
  
)

export default component.exports